import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePageBgImageView_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePageBgImageView_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class HomePageBgImageView_ScreenBase extends React.PureComponent<
  IHomePageBgImageView_ScreenProps,
  any
> {
  homepagebgimageview_132266_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "9bd32c2a-6e7e-4fa7-8fa0-be8e2f5e6c99",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 853012, PropertyName: "value", Value: "Merhaba," },
        { Id: 436750, PropertyName: "value", Value: "Simay Horasanlı" },
        { Id: 400155, PropertyName: "value", Value: "12" },
        { Id: 390709, PropertyName: "value", Value: "Açık Issue" },
        { Id: 748744, PropertyName: "value", Value: "12" },
        { Id: 747048, PropertyName: "value", Value: "Aktif Kampanya" },
        { Id: 398825, PropertyName: "value", Value: "12" },
        { Id: 782720, PropertyName: "value", Value: "Toplam Bayi" },
        { Id: 927322, PropertyName: "value", Value: "Hedef Gerçekleşme Oranı" },
        {
          Id: 600222,
          PropertyName: "value",
          Value: "Hedef Gerçekleştiren Bayi Oranı",
        },
        { Id: 543901, PropertyName: "value", Value: "12" },
        { Id: 937417, PropertyName: "value", Value: "/" },
        { Id: 223718, PropertyName: "value", Value: "20" },
        { Id: 119335, PropertyName: "value", Value: "%" },
        { Id: 390431, PropertyName: "value", Value: "45" },
        { Id: 19943, PropertyName: "value", Value: "+12" },
        { Id: 354241, PropertyName: "value", Value: "Son Eklenen Bayi" },
        { Id: 404294, PropertyName: "value", Value: "Tümü >" },
        { Id: 198396, PropertyName: "title", Value: "Title" },
        { Id: 283177, PropertyName: "value", Value: "ABC Bayi" },
        { Id: 39412, PropertyName: "value", Value: "Ana Bayi" },
        { Id: 444734, PropertyName: "value", Value: "13" },
        { Id: 687332, PropertyName: "value", Value: "Bağlı Bayi" },
        { Id: 11848, PropertyName: "value", Value: "13" },
        { Id: 399, PropertyName: "value", Value: "Şehir" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.homepagebgimageview_132266_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepagebgimageview", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepagebgimageview", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepagebgimageview", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePageBgImageViewComponent_29098_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePageBgImageView",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
